module.exports = __webpack_public_path__ + "static/media/pb_background.adb3f901.png";